// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + {"538":"recorder","983":"profiler"}[chunkId] + "." + {"538":"0b8858e8","983":"1acc45ac"}[chunkId] + ".chunk.js";
};